/**
 * Module-level clipboard for canvas copy/paste operations.
 * Stores serialized fabric object JSON independently of React state.
 */

let _clipboard: string | null = null

export function setClipboard(json: string | null): void {
    _clipboard = json
}

export function getClipboard(): string | null {
    return _clipboard
}
